const USERNAME_MIN_LENGTH = 3;
const USERNAME_MAX_LENGTH = 15;
const PASSWORD_MIN_LENGTH = 6;
const PASSWORD_MAX_LENGTH = 30;

module.exports = {
  email: isValidEmail,
  fullname: isValidFullname,
  url: isValidUrl,
  hex: isValidHex,
  username: isValidUsername,
  hasOnlyEnglishLetters: hasOnlyEnglishLetters,
  isPhoneNumber: isPhoneNumber,
  USERNAME_MIN_LENGTH,
  USERNAME_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH
};

function isPhoneNumber(phone) {
  var phoneno = /^\d{9,10}$/;
  if (phone.match(phoneno)) {
    return true;
  } else {
    return false;
  }
}

function isValidEmail(str) {
  var pattern = /^(([a-zA-Z\d_\-\+\.]+)@([a-zA-Z\d_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z\d_\-\.]+)@([a-zA-Z\d_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
  return !!pattern.test(str);
}

function isValidFullname(str) {
  // only English letters and spaces, 3 to 20 characters.
  var pattern = /^([\w\ ](?![0-9\_])){3,20}$/;

  return !!pattern.test(str);
}

function hasOnlyEnglishLetters(str) {
  var pattern = /^[A-Za-z\ ]+$/;

  return !!pattern.test(str);
}

function isValidUrl(str) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.,~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator

  return !!pattern.test(str);
}

function isValidHex(str) {
  var pattern = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

  return !!pattern.test(str);
}

function isValidUsername(str) {
  // var pattern = /[\u00BF-\u1FFF\u2C00-\uD7FFֿֿֿa-zA-Z0-9\-\.]{2,}$/;
  var pattern = new RegExp(`^[_a-zA-Z0-9]{${USERNAME_MIN_LENGTH},${USERNAME_MAX_LENGTH}}$`);

  return !!pattern.test(str);
}
